import { render, staticRenderFns } from "./PagamentoEnviarParaAnalise.vue?vue&type=template&id=230b9a2d&"
import script from "./PagamentoEnviarParaAnalise.vue?vue&type=script&lang=js&"
export * from "./PagamentoEnviarParaAnalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports